const baseConvert = (number, frombase, tobase) => {
  return parseInt(number + "", frombase | 0).toString(tobase | 0);
};

export { baseConvert };
